export default __webpack_public_path__ + "static/media/158.d2f93511.svg";